import React, { FC, ReactNode } from 'react';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { useStickyClass } from '@shared/lib/react';
import { ModalProps } from '@shared/ui/organisms';
import { SearchPayee } from '@entities/tsp';
import SearchInputButton from './SearchInputButton';
type SuggestModalProps = ModalProps;
interface NonStickySearchInputButtonProps {
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const NonStickySearchInputButton: FC<NonStickySearchInputButtonProps> = ({
  renderSuggestModal
}) => {
  const {
    ref,
    isStuck
  } = useStickyClass(65 + 8);
  return <SearchInputWrapper id="search-input-with-wrapper" ref={ref} isStuck={isStuck}>
      <SearchInputButton renderSuggestModal={renderSuggestModal} />
    </SearchInputWrapper>;
};
export default NonStickySearchInputButton;
interface SearchInputWrapperProps {
  isStuck: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isStuck
}) => isStuck ? 0 : 1;
const SearchInputWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SearchInputWrapper",
  class: "s1n63rr4",
  propsAsIs: false,
  vars: {
    "s1n63rr4-0": [_exp()]
  }
}));

require("./NonStickySearchInputButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./NonStickySearchInputButton.tsx");